const rutasInventario = [
  //Inventario
  {
    name: "mascarasInventario",
    type: "gltfModel",
    path: "modelos/mascaras/nuevo/NOMENCLATURA.gltf",
  },
  {
    name: "mascarasZonas",
    type: "gltfModel",
    path: "modelos/mascaras/MASCARAS COMUNALES.glb",
  },
  {
    name: "inventario",
    type: "json",
    path: "inventario/inventario_local.json",
  },
]

export default rutasInventario;